import React, { useEffect } from "react";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Callin from "../../About/Callin";
import Infiry from "../../About/Infiry";
import Physiotherapycon from "./Physiotherapycon";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Physiotherapy() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Physiotherapycon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Physiotherapy Centre in Vijayanagar</title>
        <meta
          name="description"
          content="We are the best physiotherapy centre in Vijayanagar and Whitefield. If you are searching for this then contact us today."
        />
        <meta
          name="keywords"
          content="Best physiotherapy centre in Whitefield, Best physiotherapy centre in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestphysiotherapyservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestphysiotherapyservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield provides expert physiotherapy services including pain relief therapies, rehabilitation after injury or surgery, mobility improvement exercises, posture correction, and personalized physical therapy programs by trained physiotherapists.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Pain relief physiotherapy",
              "Post-injury rehabilitation",
              "Post-surgical physical therapy",
              "Mobility and flexibility improvement",
              "Posture correction therapies",
              "Customized exercise programs",
              "Sports injury physiotherapy",
            ],
            keywords: [
              "best physiotherapy services in Immadihalli",
              "best physiotherapy services in Whitefield",
              "best physiotherapy services in Bangalore",
              "best physiotherapy services in Kundalahalli",
              "best physiotherapy services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Physiotherapy Centre in Vijayanagar compassionate service sets us apart
        as a leader in Physiotherapy services.Contact us for the best
        physiotherapy centre in Vijayanagar.
      </h2>
      <Servicebanner name="Physiotherapy" banner={"../photo/dd19.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Physiotherapy;
